import styles from "./SupportChatPage.module.scss";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TestimonialInput from "../../components/shared/TestimonialInput/TestimonialInput";
import React from "react";
import {useTranslation} from "react-i18next";
import AvatarBg from "../../components/icons/avatarbg";
import axiosInstance from "../../api/axios";
import {useAppSelector} from "../../store/store";
import {useDispatch} from "react-redux";
import {setSuccessToast} from "../../store/slices/modals.slice";
import SuccessToast from "../../components/shared/SuccessToast/SuccessToast";
import {RECAPTCHA_SITE_KEY} from "../../utils/helpers";
import {getUserImageUrl} from "../../utils/imageUrl";
import GradientBackdrop from "../../components/shared/GradientBackdrop/GradientBackdrop";

const SupportChatPage = () => {
  const [text, setText] = React.useState('');

  const {t, i18n} = useTranslation();
  const userData = useAppSelector((state: any) => state.auth.userData);
  const userAvatar = useAppSelector((state: any) => state.auth.userData.picture_url);
  const userAvatarUrl = getUserImageUrl(userAvatar);
  const dispatch = useDispatch();

  const sendHandler = async () => {
    try {
      if (!window.grecaptcha || !window.grecaptcha.enterprise) {
        return;
      }

      window.grecaptcha.enterprise.ready(async () => {
        const token = await window.grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, {action: "submit"});
        console.log("Получен reCAPTCHA token:", token);

        await axiosInstance.post(`/support/`, {
          'g-recaptcha-response': token,
          message: text
        })
        setText('');
        dispatch(setSuccessToast(true));
      })


    } catch (e) {
      console.log(e);
    }
  }

  const dirData = i18n.language === 'ar' ? 'rtl' : 'ltr'

  return (
    <div className={styles.supportPageWrapper}>
      <Header className={styles.headerSupport}/>

      <GradientBackdrop/>

      <SuccessToast />
      <div className={styles.supportContent}>
        <div className={styles.supportTitle}>{t('Usersupport')}</div>
        <div className={styles.supportSubTitle}>{t('suppChat1')}</div>
        <div className={styles.supportDescription}>
          {t('suppChat2')}<br/>
          {t('suppChat3')}
        </div>

        <div className={styles.avatarBlock}>
          <div
            dir={dirData}
            className={styles.avatarMain}
            style={{backgroundImage: userAvatarUrl ? `url(${userAvatarUrl})` : undefined}}
          >
            {!userAvatarUrl && (
              <>
                <AvatarBg/>
                <span>{userData?.username?.[0] || 'U'}</span>
              </>
            )}
          </div>
          <div>
            <div className={styles.avatarBlockName}>{userData?.username || 'User'}</div>
            <div className={styles.avatarBlockId}>{userData?.email || ''}</div>
          </div>
        </div>

        <div className={styles.textWrapper}>
          <TestimonialInput
            disabledFlag={false}
            placeholder={t('addComment')}
            valueHandler={setText}
            sendHandler={sendHandler}
            avatarSize={0}
          />
        </div>
        <div className={styles.subDescription}>
          {t('suppChat4')}
        </div>
      </div>
      <Footer source={''}/>
    </div>
  )
};

export default SupportChatPage;
